import { Injectable } from '@angular/core';
import { LOCALE_ID, Inject } from '@angular/core';

import { routesSeo as routesSeoEn } from './en/routes-seo';
import { routesSeo as routesSeoDe } from './de/routes-seo';
import { routesSeo as routesSeoFr } from './fr/routes-seo';
import { routesSeo as routesSeoEs } from './es/routes-seo';
import { routesSeo as routesSeoPt } from './pt/routes-seo';
import { routesSeo as routesSeoIt } from './it/routes-seo';

import { NGXLogger as LoggerService } from "ngx-logger";
import { Router } from '@angular/router';

const routesSeoByLang: { langCode: string, routesSeo: Record<string, string> }[] = [
    { langCode: "en", routesSeo: routesSeoEn as Record<string, string> },
    { langCode: "de", routesSeo: routesSeoDe as Record<string, string> },
    { langCode: "it", routesSeo: routesSeoIt as Record<string, string> },
    { langCode: "fr", routesSeo: routesSeoFr as Record<string, string> },
    { langCode: "es", routesSeo: routesSeoEs as Record<string, string> },
    { langCode: "pt", routesSeo: routesSeoPt as Record<string, string> },
]
@Injectable({
    providedIn: 'root'
})
export class AlternateHrefService {
    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private logger: LoggerService,
        private router: Router,

    ) {
    }

    /**
     * Sprach-Alternates der aktuellen Route. Entspricht die aktuelle URL exakt
     * dem `pathId`-Slug IRGENDEINER Sprache (z.B. samplePollsList:
     * /de/umfrage-vorlagen, aber auch der EN-Slug im DE-Build — routes.ts
     * registriert alle Sprach-Slugs), liefert jede Zielsprache ihren EIGENEN
     * Slug aus der jeweiligen routesSeo-Map — /de/umfrage-vorlagen und
     * /en/poll-templates verweisen so korrekt aufeinander.
     *
     * Alle anderen Routen (mehrsegmentige URLs wie vote/{ids}, Query-Params,
     * ids ohne routesSeo-Eintrag) behalten das bisherige Verhalten "gleiche
     * URL fuer alle Sprachen" — das sind durchweg noindex-Routen.
     */
    public getAlternateHrefLangs(pathId: string): { langCode: string, url: string }[] {
        const url = this.router.url.replace("/", "")
        this.logger.log('getAlternateHrefLangs', pathId, url)
        const isPlainSlugRoute = routesSeoByLang.some(({ routesSeo }) => routesSeo[pathId] === url);
        const returnArray = routesSeoByLang.map(({ langCode, routesSeo }) => ({
            langCode,
            url: isPlainSlugRoute && routesSeo[pathId] !== undefined ? routesSeo[pathId] : url,
        }));
        this.logger.log('getAlternateHrefLangs', returnArray)
        return returnArray
    }



}
